import Rest from './base/Rest';

export default class AccessService extends Rest {
    static resource = 'access';
}
